import apis from "../services/api";

export const getUserProfile = async (business) => {
  try {
    const response = await apis.get("/user/profile", { params: { business } });
    return response.data;
  } catch (error) {
    console.log("getUserProfile ~ error:", error);
    if (error.status === 403) {
      window.location.href = "https://id.kido.vn/login/?redirect_url=" + encodeURI(location.href);
      return;
    }
  }
};

export const getModelSettings = async (business) => {
  try {
    const response = await apis.get("/question/models", { params: { business } });
    return response.data;
  } catch (error) {
    console.log("getModelSettings ~ error:", error);
  }
};

export const getReminders = async ({ business, page = 0, size = 500, order = "desc", isMobile, reminderId }) => {
  try {
    const params = { business, page, size, order, reminderId };
    if (isMobile) {
      params.deliveryMethod = "DELIVERY_METHOD_IN_APP";
    }
    const response = await apis.get("/reminders/deliveries", { params });
    return response.data;
  } catch (error) {
    console.log("getReminders ~ error:", error);
  }
};

export const getReminderDetail = async ({ business, reminderId = "", isMobile }) => {
  try {
    const params = { business, id: reminderId };
    if (isMobile) {
      params.deliveryMethod = "DELIVERY_METHOD_IN_APP";
    }
    const response = await apis.get("/reminders/detail", { params });
    return response.data;
  } catch (error) {
    console.log("getReminder ~ error:", error);
  }
};

export const getFollowUpQuestionByReminder = async ({ business, reminderId }) => {
  try {
    const params = { business, id: reminderId };
    const response = await apis.get("/reminders/suggested_questions", { params });
    return response.data;
  } catch (error) {
    console.log("getFollowupQuestionByReminder ~ error:", error);
  }
};

export const getChatHistory = async () => {
  try {
    const response = await apis.get("/question/chat_histories");
    return response.data;
  } catch (error) {
    console.log("getChatHistory ~ error:", error);
  }
};

export const getSuggestedQuestions = async () => {
  try {
    const response = await apis.get("/question/suggested_questions");
    return response.data;
  } catch (error) {
    console.log("getSuggestedQuestions ~ error:", error);
    return null;
  }
};
